import { KeyboardArrowDown } from '@mui/icons-material'
import { Button, Menu, MenuItem } from '@mui/material'
import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { lightBlue } from 'src/utils/colors'

interface propTypes {
  id?: string
  path?: string
  onClick?: () => void
  children: string
  submenu?: { path: string; title: string }[]
}
const NavItem: React.FC<propTypes> = (props) => {
  const { id, path, onClick, children, submenu } = props
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  if (id) {
    return (
      <>
        <Button
          onClick={open ? handleClose : handleClick}
          id="menu-button"
          aria-controls={open ? 'menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          endIcon={
            <KeyboardArrowDown
              sx={{
                transform: open ? 'rotate(180deg)' : '',
                transition: 'transform 167ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
              }}
            />
          }
          sx={{
            px: '8px',
            py: '6px',
            color: lightBlue,
            letterSpacing: '1.8px',
            cursor: 'pointer',
            textTransform: 'none',
            fontWeight: '500',
            fontSize: '1rem',
            lineHeight: '1.5',
            borderRadius: '0',
            ':hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
          }}
        >
          {children}
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          disableScrollLock
          MenuListProps={{
            'aria-labelledby': 'menu-button',
          }}
          sx={{ display: 'flex' }}
        >
          {submenu &&
            submenu.map((item, index) => (
              <NavLink
                key={index}
                to={item.path ? item.path : '/'}
                style={{
                  textDecoration: 'none',
                }}
                onClick={onClick}
              >
                <MenuItem
                  onClick={handleClose}
                  sx={{
                    px: 2,
                    my: 1,
                    color: lightBlue,
                    fontWeight: '500',
                  }}
                >
                  {item.title}
                </MenuItem>
              </NavLink>
            ))}
        </Menu>
      </>
    )
  }

  return (
    <NavLink
      to={path ? path : '/'}
      style={{
        textDecoration: 'none',
      }}
      onClick={onClick}
    >
      <MenuItem
        sx={{
          pr: { xs: 2, md: 1 },
          pl: { xs: 0, md: 1 },
          color: lightBlue,
          letterSpacing: '1.8px',
        }}
      >
        {children}
      </MenuItem>
    </NavLink>
  )
}

export default NavItem
